import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyAwqb_T4gObbYB3NonTw7Qk3GQ0nxF9BzA",
  authDomain: "loginfirebase-9d539.firebaseapp.com",
  databaseURL: "https://loginfirebase-9d539-default-rtdb.firebaseio.com",
  projectId: "loginfirebase-9d539",
  storageBucket: "loginfirebase-9d539.firebasestorage.app",
  messagingSenderId: "975620703335",
  appId: "1:975620703335:web:65d24d89cf31af6db680c2",
  measurementId: "G-J11XTE1H2N"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);

export { auth };